export enum MFACodes {
  APP = 'app',
  SMS = 'sms',
  EMAIL = 'email',
}
